<script>
export default {
  name: 'Socials',
  props: {
    social: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<template>
  <a :href="social.link" target="_blank">
    <img
      :src="require(`@/assets/img/${$chain.getName()}/footer/social/ic-${social.icon}.svg`)"
      :alt="social.icon"
    />
  </a>
</template>

<style lang="scss" scoped>
</style>
